/**
 * Labstep
 *
 * @module grid/SmartTableProtocolValue/coldefs
 * @desc Grid SmartTable Column Definitions
 */

import {
  fieldCAS,
  fieldMolecularFormula,
  fieldMolecularWeight,
  fieldName,
} from 'labstep-web/components/PubChemMetadata/Form/fields';
import { getMetadataMoleculePubchemColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/molecule/pubchem';
import { getMetadataMoleculeSafetyColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/molecule/safety';
import { getMetadataMoleculeStructureColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/metadata/molecule/structure';
import type { SmartTableColDef } from 'labstep-web/grid/SmartTableProtocolValue/coldefs/types';
import type { Experiment } from 'labstep-web/models/experiment.model';
import type { Metadata } from 'labstep-web/models/metadata';
import type { Protocol } from 'labstep-web/models/protocol.model';

export const getMetadataMoleculeColDefs = (
  experimentOrProtocol: Experiment | Protocol,
  metadata: Metadata,
  protocolValueName?: string,
): SmartTableColDef[] =>
  metadata.label
    ? [
        getMetadataMoleculeStructureColDef(
          experimentOrProtocol,
          metadata.parent_entity_class,
          metadata.type,
          metadata.label,
          protocolValueName,
        ),
        getMetadataMoleculePubchemColDef(
          experimentOrProtocol,
          metadata.parent_entity_class,
          metadata.type,
          metadata.label,
          'Name',
          fieldName,
          protocolValueName,
        ),
        getMetadataMoleculePubchemColDef(
          experimentOrProtocol,
          metadata.parent_entity_class,
          metadata.type,
          metadata.label,
          'CAS Number',
          fieldCAS,
          protocolValueName,
        ),
        getMetadataMoleculePubchemColDef(
          experimentOrProtocol,
          metadata.parent_entity_class,
          metadata.type,
          metadata.label,
          'Molecular Formula',
          fieldMolecularFormula,
          protocolValueName,
        ),
        getMetadataMoleculePubchemColDef(
          experimentOrProtocol,
          metadata.parent_entity_class,
          metadata.type,
          metadata.label,
          'Molecular Weight',
          fieldMolecularWeight,
          protocolValueName,
        ),
        getMetadataMoleculeSafetyColDef(
          experimentOrProtocol,
          metadata.parent_entity_class,
          metadata.type,
          metadata.label,
          protocolValueName,
        ),
      ]
    : [];
